import React from 'react';

import Table from 'components/clarity-ui/components/table/table';
import TableHeader from 'components/clarity-ui/components/table/tableHeader';
import TableRow from 'components/clarity-ui/components/table/tableRow';
import TableData from 'components/clarity-ui/components/table/tableData';

class WebPagesTableComponent extends React.Component {

  renderTableRows () {
    const { entitiesWebPages } = this.props;
    let tableRows = [];

    tableRows = entitiesWebPages.map((item) => {
      const { id, remoteId, title } = item;
      return (
        <TableRow key={id}>
          <TableData><a href={remoteId} target="_blank">{title}</a></TableData>
        </TableRow>
      );
    });

    if (tableRows.length === 0) {
      tableRows.push(
        <TableRow key='empty-entity-web-table'>
          <TableData style={{maxWidth: 50+'px'}}>No Web Pages found</TableData>
        </TableRow>
      );
    }

    return tableRows;
  }

  renderTable () {
    return (
      <Table scrollable>
        <thead>
          <TableRow isHeader>
            <TableHeader>Web Pages</TableHeader>
          </TableRow>
        </thead>
        <tbody>
          { this.renderTableRows() }
        </tbody>
      </Table>
    );
  }

  render () {
    return (
      <div>
        { this.props.isExecuteClicked ? this.renderTable() : null }
      </div>
    );
  }
}

export default WebPagesTableComponent;



// WEBPACK FOOTER //
// ./src/components/entityRecommender/entityWebPagesTable.component.jsx